export default __webpack_public_path__ + "static/media/PROCESSMETHOD_MOLDING_INJECTION.9ae3f362.png";